// ====================
//  scrollのfadeinアニメーション
// ====================
function io() {
  //対象クラス名
  const animTargets = [".js-anim", ".js-io"].join(",");

  const targets = document.querySelectorAll(animTargets);
  const options = {
    root: null,
    rootMargin: "-10% 0px -20% 0px",
    threshold: [0],
  };

  function callback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("is-active");
        observer.unobserve(entry.target);
      } //else {
      //entry.target.classList.remove("is-active");
      //}
    });
  }

  const observer = new IntersectionObserver(callback, options);

  targets.forEach((target) => {
    observer.observe(target);
  });
}

export { io };
